import React from 'react';
import PartnerStyles from "views/development/PartnerStyles.module.scss";


export const GlamstarView = [
  {
    title: 'O Glamstar 2022 está vindo aí!',
    alt: 'Realize a sua 1ª venda de um plano anual com o seu cupom de Glampartner e ganhe um mimo.',
    details: (
      <>
        <h3>O que é o Glamstar?</h3>

        <p>
          O Glamstar é o concurso que revelará a mais nova influenciadora do Brasil! Em sua terceira edição,
          essa competição vem com novos challenges, madrinhas e um super evento na grande final! 
          A ganhadora leva o prêmio de R$100 MIL em contrato com a Glambox, enquanto a segunda e a terceira
          colocadas ganham R$50 MIL e R$20 MIL em contrato, respectivamente. Além disso, contaremos com três
          super madrinhas da competição, que são influenciadoras consagradas no universo da internet e vão
          te ajudar nessa jornada! ✨🚀
        </p>
        
        <p>
          Fique ligada nas nossas redes sociais para acompanhar todas as novidades da competição!
        </p>

        <h3>Sendo uma Glampartner, como faço para participar?</h3>
        
        <p>
          Olha que ótima notícia: a sua vaga já está garantida na competição! Não é necessário realizar
           nenhuma nova inscrição no site do Glamstar. Basta aguardar o início do concurso, arrasar nos 
           challenges e torcer para ser uma das finalistas! 😱
        </p>

        <h3>Quais são os challenges?</h3>
        
        <p>
          Os challenges serão surpresa! Mas prepare-se: será incrível! As nossas madrinhas vão lançar 
          esses desafios ao longo dos meses e, claro, ajudar na decisão final para revelar a mais nova
           influenciadora do Brasil! 💕😍
        </p><br/><br/>

        <div className={PartnerStyles["video-glamstar"]}>
          <img src={'https://via.placeholder.com/140x75'} alt="140x100" />
          <iframe width="800" height="496" src="https://www.youtube.com/embed/7hdV_mupYPc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </div>
      </>
    ),
  },
];